/*
 * @Author: zhangsheng
 * @Date: 2023-09-15 10:59:20
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-09-25 15:36:32
 * @FilePath: \panda-index-sicermem-frontend\src\locales\en.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import index from './en-US/index';
import coreTechnology from './en-US/coreTechnology';
import applicationArea from './en-US/applicationArea';
import contactUs from './en-US/contactUs';
import aboutUs from './en-US/aboutUs';
import product from './en-US/product';
export default {
  ...index,
  ...coreTechnology,
  ...applicationArea,
  ...contactUs,
  ...aboutUs,
  ...product,

  'Layout.index.749881-0': 'Company Introduction',
  'Layout.index.749881-1': 'Enterprise Strength',
  'Layout.index.749881-2': 'Testing Center',
  'Layout.index.749881-3': 'Corporate Purpose',
  'Layout.index.749881-4': 'Enterprise Qualification',
  'Layout.index.749881-5': 'About Us',
  'Layout.index.749881-6': 'Product Center',
  'Layout.index.749881-7': 'All',
  'Layout.index.749881-8': 'Series Products',
  'Layout.index.749881-9': 'Order',
  'Layout.index.749881-10': 'No detailed data currently available',
  'Layout.index.749881-11': 'search',
  'Layout.index.749881-12': 'Flat Ceramic Membrane (Common)',
  'Layout.index.749881-13': 'Glass Fiber Membrane Module',
  'Layout.index.749881-14': 'Home',
  'Index.technology.260118-0': 'Technology Application',

  'utils.util.037612-0': 'Please enter the password',
  'utils.util.037612-1': 'Please enter no more than 8-16 characters',
  'utils.util.037612-2': 'Passwords must contain uppercase, lowercase letters, and numbers or special characters',
  'utils.util.037612-3': 'Please enter your phone number',
  'utils.util.037612-4': 'Please enter a phone number in the correct format',
};
